import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Eagan, MN?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office in Eagan can take 2–6 months. For business travelers at Eagan's corporate campuses and families with upcoming international plans, that timeline simply does not work.",
  },
  {
    q: "Can corporate travelers in Eagan get an expedited passport quickly?",
    a: "Absolutely. Eagan has one of the highest concentrations of corporate headquarters in Dakota County. Thomson Reuters, Blue Cross Blue Shield, and Capella University employees regularly need expedited renewals with two to three weeks notice. We process renewals as fast as 2–9 business days for Eagan professionals.",
  },
  {
    q: "What is the closest passport acceptance office to Eagan?",
    a: "The Eagan Post Office on Pilot Knob Road accepts passport applications by appointment. Burnsville and Apple Valley post offices are nearby alternatives. For first-time applicants and minors who need an acceptance clerk visit, we provide clear instructions on which local facility is best for your situation.",
  },
  {
    q: "Do I need to visit a local office to use Fast Passport Center?",
    a: "No — most Eagan travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Eagan. Start your order online, follow the personalized checklist, and ship overnight from anywhere in the south metro.",
  },
  {
    q: "What documents do I need for an expedited passport renewal in Eagan?",
    a: "For most renewals: your current or most recent expired passport, a completed DS-82 form, two passport photos, and payment. We provide a full personalized checklist after you start your order. Our document review catches issues that would otherwise delay or reject your application.",
  },
  {
    q: "Can my child get a passport quickly if we have a family trip coming up?",
    a: "Yes. Child passports require an in-person acceptance clerk visit with both parents or special consent forms. We guide Eagan families through the exact process, paperwork, and local acceptance locations so your child's passport is ready on time for your trip.",
  },
  {
    q: "How quickly can Burnsville and Apple Valley residents receive an expedited passport?",
    a: "Burnsville and Apple Valley travelers have the same access to our expedited services as Eagan residents. Since we operate remotely, your physical location in Dakota County does not affect processing speed. Ship your documents overnight from any UPS or FedEx location, and we handle the rest.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing.",
  },
];

export default function EaganFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Eagan and south metro travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}